import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getValidToken } from "../../../utils/tokenManager";
import axios from "axios";

/**
 * Extracted from admin/Dashboard.jsx - same fetch, same filter/sort
 * logic, same endpoint. Desktop still keeps its own copy for now (this
 * hook currently only powers the new mobile screen) - a low-risk,
 * additive extraction since Dashboard.jsx's own logic is untouched.
 */
export function useAdminDashboard() {
  const { t } = useTranslation();
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("agent_name");
  const [sortConfig, setSortConfig] = useState({ field: null, direction: null });

  const clinentId = sessionStorage.getItem("clinentId");

  const fetchAgents = async (startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const accessToken = await getValidToken();
      let start_date, end_date;
      if (startDate && endDate) {
        start_date = startDate.format("YYYY-MM-DD");
        end_date = endDate.format("YYYY-MM-DD");
      } else {
        const today = new Date();
        start_date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
        end_date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        ).getDate()}`;
      }
      const response = await axios.request({
        method: "get",
        url: `${process.env.REACT_APP_APIBASEURL}/api/dashboard/agents`,
        params: {
          start_date,
          end_date,
          ...(clinentId ? { client_id: clinentId } : {}),
        },
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      let agentsData = response.data.agents || [];
      if (clinentId) {
        agentsData = agentsData.filter((agent) => String(agent.client_id) === String(clinentId));
      }
      setAgents(agentsData);
    } catch (err) {
      setError(t("dashboard.errorFetchingAgents") || "Error fetching agents");
    } finally {
      setLoading(false);
    }
  };

  const filteredAgents = agents.filter((agent) => {
    if (!searchTerm) return true;
    const fieldValue = agent[searchField];
    if (!fieldValue) return false;
    return fieldValue.toString().toLowerCase().includes(searchTerm.toLowerCase());
  });

  const sortedAgents = [...filteredAgents].sort((a, b) => {
    const { field, direction } = sortConfig;
    if (!field || !direction) return 0;
    const valueA = (a[field] || "").toString().toLowerCase();
    const valueB = (b[field] || "").toString().toLowerCase();
    return direction === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });

  return {
    agents,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    searchField,
    setSearchField,
    sortConfig,
    setSortConfig,
    sortedAgents,
    fetchAgents,
  };
}